<template>
	<span v-if="date" class="mt-3" :class="textColor"> {{mwTranslate('date', name )}} <span v-if="name">:</span> {{ new Date(date) | moment(format) }}</span>
</template>

<script>
	export default{
		name: "DateNote", 
		props: {
			name: {type: String},
			date: { },
			color: {type: String, default: () => "grey"},
			format: {type: String, default: () => "D.MM.YYYY" }
		},
		computed: {
			textColor(){
				var classes = {}
				classes[this.color +"--text"] = true;
				return classes
			}
		}
	}
</script>